import { Button } from "@mui/material";
import type React from "react";
import { useImportSalePrices } from "../hooks/use-import-sale-prices";
import { ImportPriceListModal } from "./import-price-list-modal";

export const ImportPriceListButton: React.FC = () => {
  const {
    isModalOpen,
    selectedFile,
    parseErrors,
    parsedRowData,
    onSubmit,
    onClose,
    onSelectedFileChange,
    setIsModalOpen,
  } = useImportSalePrices();

  return (
    <>
      <ImportPriceListModal
        isOpen={isModalOpen}
        onSubmit={onSubmit}
        onCancel={onClose}
        selectedFile={selectedFile}
        onSelectedFileChange={onSelectedFileChange}
        parseErrors={parseErrors}
        parsedRowData={parsedRowData}
      />
      <Button
        variant="outlined"
        onClick={() => {
          setIsModalOpen(true);
        }}
      >
        Import Price List
      </Button>
    </>
  );
};
